module.exports = __webpack_public_path__ + "img/bb_g3_t_mouth-04.ff0fe8c5.svg";